// extracted by mini-css-extract-plugin
export default {"downloadButtonContainer":"Download_downloadButtonContainer__F7tse"};